import { Routes } from 'react-router-dom'
import getRenderedRoutes from '../helpers/getRenderedRoutes'
import routes from './routes'

const AppRoutes = () => {
    return <Routes>{getRenderedRoutes(routes)}</Routes>
}

export default AppRoutes
